import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
//import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';//, formValueSelector
import { Input } from '../components/Forms/Input';
import { required } from '../validation';
import { authentication, session } from '../authentication';

let LoginForm = (props) => {
    const { handleSubmit } = props;
    return (
        <form onSubmit={handleSubmit} className="form-group">
            <Field className="form-group form-control" name="email" type="email" component={Input} label="Email" validate={required} />
            <Field className="form-group form-control" name="password" type="password" component={Input} label="Password" validate={required} />
            <button className="btn btn-primary" type="submit" style={{ marginTop: "10px" }}>Log in</button>
        </form>)
}

LoginForm = reduxForm({ form: 'LoginForm' })(LoginForm);

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        authentication.login(e.email, e.password)
            .then(_ => {
                this.setState({ error: false })
            })
            .catch(_ => {
                this.setState({ error: true })
            });
    }


    render() {
        let user = session.getUser();
        if (user) {
            return (<Redirect to={`/Projects`} />)
        }

        return (
            <div className="panel panel-default h-center modal-dialog">
                <div className="panel-heading"><h1>Log in</h1></div>
                <div className="panel-body">
                    {
                        this.state.error ? <div className="alert alert-danger">Sorry, we couldn't recognise your username and/or password. Would you like to <Link className="alert-link" to="/ForgotPassword">change your password</Link>?</div> : null
                    }
                    <LoginForm onSubmit={this.handleSubmit} />
                </div>

                <div className="panel-footer">
                    <Link to="/ForgotPassword">Forgot your password?</Link>
                </div>
            </div>
        )
    }
}
export default Login;